import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import ArticlePrzewodnik from "../pages/article/kakobuy-spreadsheet-przewodnik/page";
import ArticleSneakers from "../pages/article/kakobuy-sneakers-spreadsheet/page";
import ArticleStreetwear from "../pages/article/kakobuy-streetwear-spreadsheet/page";
import ArticleSafety from "../pages/article/kakobuy-bezpieczenstwo-zakupow/page";
import ArticleShipping from "../pages/article/kakobuy-wysylka-polska/page";
import ArticleBeginner from "../pages/article/kakobuy-jak-zaczac/page";
import ArticleFinds from "../pages/article/kakobuy-najlepsze-finds/page";
import ArticleQC from "../pages/article/kakobuy-qc-zdjecia/page";
import ArticlePayments from "../pages/article/kakobuy-platnosci/page";
import ArticleUpdate from "../pages/article/kakobuy-spreadsheet-aktualizacja/page";

const routes: RouteObject[] = [
  { path: "/", element: <Home /> },
  { path: "/artykul/kakobuy-spreadsheet-przewodnik", element: <ArticlePrzewodnik /> },
  { path: "/artykul/kakobuy-sneakers-spreadsheet", element: <ArticleSneakers /> },
  { path: "/artykul/kakobuy-streetwear-spreadsheet", element: <ArticleStreetwear /> },
  { path: "/artykul/kakobuy-bezpieczenstwo-zakupow", element: <ArticleSafety /> },
  { path: "/artykul/kakobuy-wysylka-polska", element: <ArticleShipping /> },
  { path: "/artykul/kakobuy-jak-zaczac", element: <ArticleBeginner /> },
  { path: "/artykul/kakobuy-najlepsze-finds", element: <ArticleFinds /> },
  { path: "/artykul/kakobuy-qc-zdjecia", element: <ArticleQC /> },
  { path: "/artykul/kakobuy-platnosci", element: <ArticlePayments /> },
  { path: "/artykul/kakobuy-spreadsheet-aktualizacja", element: <ArticleUpdate /> },
  { path: "*", element: <NotFound /> },
];

export default routes;